/**
 * Shell visual del Portal de Clientes (separado del Layout del despacho).
 */
import { Link } from "react-router-dom";

export default function PortalMaterialidadShell({ children, footer = null }) {
  return (
    <div
      className="min-h-screen bg-gradient-to-b from-slate-100 via-white to-slate-50 text-slate-900"
      data-testid="portal-materialidad-shell"
    >
      <header className="border-b border-slate-200 bg-white/90 backdrop-blur">
        <div className="mx-auto max-w-3xl px-4 py-4 flex items-center justify-between gap-3">
          <Link to="/portal-materialidad" className="no-underline">
            <p className="text-lg font-semibold tracking-tight text-[#0F2D5C]">Portal de clientes</p>
            <p className="text-xs text-slate-500">Carga documental · Materialidad</p>
          </Link>
          <Link
            to="/login"
            className="text-xs text-slate-500 hover:text-[#0F2D5C] no-underline"
          >
            Acceso despacho
          </Link>
        </div>
      </header>
      <main className="mx-auto max-w-3xl px-4 py-8">{children}</main>
      {footer}
    </div>
  );
}
